import {Component, Input} from '@angular/core';

import {AdjusterPresetsService, Factor} from '../adjuster-presets.service';

@Component({
  selector: 'pra-dataset-list',
  templateUrl: './dataset-list.component.html',
  styleUrls: ['./dataset-list.component.scss'],
})
export class DatasetListComponent {
  @Input() factor: Factor;
  datasetListVisible = false;

  constructor(public adjusterPresetsService: AdjusterPresetsService) {}

  getLabelInCurrentLang(labels) {
    return this.adjusterPresetsService.getLabelInCurrentLang(labels);
  }
}
